import React from 'react';
import Rive from '@rive-app/react-canvas';
const Loader = props => (
	<div className='showRiveLoader generalLoader'>
		<Rive src='/rive_loader.riv' style={{ width: '125px', height: '125px' }} />
	</div>
);

export default Loader;
